import Icon, { IconName } from '@/components/icon'
import Styles from './style.module.scss'

interface DataItemProps {
  icon: IconName
  title: string
  description: string
}

const TITLE = 'Project Financing Options'
const data: DataItemProps[] = [
  {
    icon: 'blueNote',
    title: 'Pay As Irvine See Result(PSR )',
    description:
      'Let us build a few pilot projects for Irvine at Carus cost.\nCarus gets paid for electricity saving.\nIrvine have option to buy anytime you want.',
  },
  {
    icon: 'blueComputer',
    title: 'Joint Venture to reduce Irvine city electricity cost',
    description: 'Carus provide Green Energy Solution.\nIrvine provide space and support.',
  },
  {
    icon: 'blueLedger',
    title: 'Lease & Sell to save initial investment in project development for city',
    description:
      'Carus raises funds to complete project development.\nThe City lease system with the option to purchase the project at\na suitable time.',
  },
  {
    icon: 'blueIncome',
    title: 'Financial Support',
    description:
      'Collaboration with banks and financial institutions provides project loan\naccess,easing upfront financial constraints.',
  },
]

export default function FinancingOption() {
  return (
    <div className={Styles.financingOption}>
      <h2>{TITLE}</h2>
      <div className={Styles.gridCard}>
        {data.map(item => (
          <div key={item.title} className={Styles.card}>
            <Icon name={item.icon} className={Styles.icon} />
            <div className={Styles.title}>{item.title}</div>
            <div className={Styles.description}>{item.description}</div>
          </div>
        ))}
      </div>
    </div>
  )
}
